module.exports = __webpack_public_path__ + "od-shield-protect-icon/od-shield-protect-icon-929e11567e0b2c71f1f4fafdac6590b2.svg";